import { motion } from 'framer-motion';
import Footer from '../components/Footer';

const SbusPage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <div>
      <section className="pt-32 pb-20 bg-gradient-to-br from-tev-green to-tev-green-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <h1 className="text-5xl font-bold mb-6">How Our Operations Are Organised</h1>
            <p className="text-xl max-w-3xl mx-auto opacity-90">
              Value chain approach for quality and efficiency
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Value Chain Approach */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="mb-20"
          >
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <motion.div variants={itemVariants}>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Value Chain Approach</h2>
                <div className="space-y-4">
                  <p className="text-lg text-gray-700 leading-relaxed">
                    We take a value chain approach in our operations. This is to ensure that end-to-end, our end-products meet the highest quality 
                    and production standards.
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    This also assists us to manage our supply chains in an effective and efficient manner. Our Group operations are therefore 
                    classified under three strategic business units, each overseen and led by qualified experts.
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed font-semibold">
                    These comprise Agronomy, Value Addition and Trading.
                  </p>
                </div>
              </motion.div>
              <motion.div variants={itemVariants} className="relative">
                <img 
                  src="/images/AFRI OILS_21.jpg" 
                  alt="Value Chain Operations" 
                  className="rounded-xl shadow-2xl w-full h-96 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-xl"></div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SbusPage;
